import { apiRequestActions } from '@ackee/redux-utils';

import { fetchAverageTripsTypes } from './types';

export default apiRequestActions(fetchAverageTripsTypes, { isDetailRequest: true });
